import { render } from "./TheSidebarMenuItem.vue?vue&type=template&id=f344983e&scoped=true"
import script from "./TheSidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./TheSidebarMenuItem.vue?vue&type=script&lang=js"

import "./TheSidebarMenuItem.vue?vue&type=style&index=0&id=f344983e&lang=scss"
import "./TheSidebarMenuItem.vue?vue&type=style&index=1&id=f344983e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f344983e"]])

export default __exports__